import { combineReducers } from '@reduxjs/toolkit';
import loginReducer from './Pages/LoginPage/loginSlice';
import passwordRecoveryReducer from './Pages/PasswordRecoveryPage/passwordRecoverySlice';
import signupReducer from './Pages/SignUpPage/signupReducer';
import signupByInviteReducer from './Pages/SignUpByInvitePage/signUpByInviteSlice';
import baseAuthReducer from './authSlice';

export const authReducer = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  signupByInvite: signupByInviteReducer,
  passwordRecovery: passwordRecoveryReducer,
  basic: baseAuthReducer,
});

export default authReducer;
